"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTES = void 0;
exports.ROUTES = {
    ROOT: '/',
    RESET_PASSWORD: '/reset-password',
    CHANGE_PASSWORD: '/password',
    SET_PASSWORD: '/set-password',
    LOGIN: '/login',
    SIGN_UP: '/sign-up',
    EXTERNAL_SIGN_UP: '/external-signup',
    LOGOUT: '/logout',
    HOME: '/home',
    INVALID_INVITATION: '/invalid-invitation',
    EXPORT_COMPLIANCE: '/export-compliance',
    VERIFIED_EMAIL: '/verified-email',
    VERIFICATION_TOKEN_NOT_FOUND: '/verification-token-not-found',
    ERROR: '/error',
    NOT_FOUND: '/404',
    LOGIN_OR_SIGN_UP: '/login-or-signup',
    MFA: '/mfa',
    SAML_LOGIN: '/saml-login',
    MISSING_ORG: '/missing-organization',
    PASSWORD_CHANGED: '/password-changed',
};
//# sourceMappingURL=routes.js.map